<template>
  <!-- Two ways in: the phone camera ("live" photo on site) or files from
       the device. HEIC is converted and images resized before upload. -->
  <div class="photo-picker">
    <button
      type="button"
      class="button"
      :disabled="loading || busy"
      @click="$refs.camera.click()"
    >
      <span class="icon"><i class="mdi mdi-camera" /></span>
      <span>{{ $t("take_photo") }}</span>
    </button>
    <span
      v-if="busy"
      class="is-size-7 has-text-grey ml-2"
    >{{ $t("upload_processing") }}</span>

    <!-- Drop zone: slide photos here, no need to browse -->
    <b-upload
      v-if="dropZone"
      v-model="dropped"
      drag-drop
      multiple
      expanded
      accept="image/*,.heic,.heif"
      class="photo-drop"
      :disabled="loading || busy"
      @input="onDropped"
    >
      <section class="section py-4">
        <div class="content has-text-centered">
          <p class="mb-1">
            <b-icon
              icon="upload"
              size="is-medium"
            />
          </p>
          <p class="is-size-7 mb-0">
            {{ $t("drop_or_click_photos") }}
          </p>
        </div>
      </section>
    </b-upload>

    <input
      ref="camera"
      type="file"
      accept="image/*"
      capture="environment"
      class="is-hidden"
      @change="onPicked"
    >
  </div>
</template>

<script>
import { resizeImage, convertHeicImage } from "@/services/helpers";

export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    resize: {
      type: Number,
      default: 1600,
    },
    dropZone: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      busy: false,
      dropped: [],
      heicTypes: ["image/heic", "image/heif"],
    };
  },
  methods: {
    onDropped(files) {
      const picked = Array.from(files || []);

      this.dropped = [];
      this.process(picked);
    },
    async onPicked(event) {
      const picked = Array.from(event.target.files || []);

      event.target.value = "";
      this.process(picked);
    },
    async process(picked) {
      if (!picked.length) {
        return;
      }
      this.busy = true;

      const files = [];

      for (let file of picked) {
        try {
          if (this.heicTypes.includes(file.type) || /\.hei[cf]$/i.test(file.name)) {
            file = await convertHeicImage(file);
          }
          if ((file.type || "").startsWith("image/")) {
            file = await resizeImage(file, this.resize);
          }
          files.push(file);
        } catch (e) {
          console.error(e);
          files.push(file);
        }
      }
      this.busy = false;
      this.$emit("files", files);
    },
  },
};
</script>

<style scoped>
.photo-picker {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.photo-drop {
  flex-basis: 100%;
  margin-top: 4px;
}
</style>
